var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"success"},[_c('div',{staticClass:"success__row"},[_vm._m(0),_c('div',{staticClass:"success__cell"},[_vm._v(" "+_vm._s(_vm.$t('PAYMENT_CARD.ACCEPT.SUCCESS'))+" ")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"success__cell"},[_c('i',{staticClass:"success__icon el-icon-success"})])
}]

export { render, staticRenderFns }